export default "__VITE_ASSET__DG1Ev0ip__"